
const SSO_PROBE_TIMEOUT_MS = 1500;

export async function canUseSilentSso(url: string): Promise<boolean> {
  try {
    const res = await fetch(url, {
      method: 'GET',
      cache: 'no-store',
      signal: AbortSignal.timeout(SSO_PROBE_TIMEOUT_MS),
    });
    if (!res.ok) return false;

    const xfo = (res.headers.get('x-frame-options') ?? '').toLowerCase();
    if (xfo.includes('deny')) return false;

    const csp = (res.headers.get('content-security-policy') ?? '').toLowerCase();
    if (csp) {
      const ancestors = /frame-ancestors([^;]*)/.exec(csp)?.[1];
      if (ancestors?.includes("'none'")) return false;

      const scriptSrc =
        /(?:^|;)\s*script-src([^;]*)/.exec(csp)?.[1] ??
        /(?:^|;)\s*default-src([^;]*)/.exec(csp)?.[1];
      if (scriptSrc !== undefined && !/'unsafe-inline'|'sha\d{3}-|'nonce-/.test(scriptSrc)) {
        return false;
      }
    }
    return true;
  } catch {
    return true;
  }
}
